import React from 'react';
import { Button, Row, Col, Card } from 'react-bootstrap';
import { SendFill } from 'react-bootstrap-icons';

const Step3Signature = ({ onSubmit, onBack, data, updateFormData }) => {
  const handleSelection = (value) => {
    updateFormData({ includeSignatureService: value });
  };

  const isNextDisabled = typeof data.includeSignatureService !== 'boolean';

  return (
    <div className="p-4">
      <div className="wizard-header">
        <h4 className="mb-0">Firma Electrónica</h4>
      </div>
      <Row>
        <Col md={6} className="d-flex flex-column justify-content-center">
          <Card className="p-4 text-center">
            <Card.Body>
              <Card.Title as="h5">¿Deseas incluir nuestro servicio de gestión de firma electrónica?</Card.Title>
              <div className="d-grid gap-2 mt-4">
                <Button
                  variant={data.includeSignatureService === true ? 'primary' : 'outline-primary'}
                  onClick={() => handleSelection(true)}
                >
                  Sí, incluir gestión
                </Button>
                <Button
                  variant={data.includeSignatureService === false ? 'secondary' : 'outline-secondary'}
                  onClick={() => handleSelection(false)}
                >
                  No, la tramitaré por mi cuenta
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <h5>¿Qué es la firma electrónica?</h5>
          <p className="text-muted">
            Es un archivo especial (criptográfico) que incluye datos del contribuyente. Cada factura emitida es firmada electrónicamente, esto asegura que no pueda ser alterada y garantiza su autenticidad. Es un requisito para facturar mediante PAC.
          </p>
          <h5>¿Qué tiempo toma la tramitación?</h5>
          <p className="text-muted">
            Al rededor de 4 días.
          </p>
        </Col>
      </Row>

      <div className="d-flex justify-content-between mt-5">
        <Button variant="secondary" onClick={onBack}>
          Anterior
        </Button>
        <Button
          onClick={onSubmit}
          disabled={isNextDisabled}
          variant="primary"
          className="d-inline-flex align-items-center gap-2"
        >
          Enviar Solicitud de Cotización
          <SendFill size={18} />
        </Button>
      </div>
    </div>
  );
};

export default Step3Signature;
